import { LOCATION_LOADING,LOCATION_ERROR,LOCATION_SUCCESS,SWAP,NOT_SWAP } from "./actionTypes";

export const SwapComponent=()=>(dispatch)=>{
    dispatch({type:SWAP})
}
export const NotSwapComponent=()=>(dispatch)=>{
    dispatch({type:NOT_SWAP})

}
export const FetchLocation=(postalCode)=>async(dispatch)=>{
    try {
        dispatch({type:LOCATION_LOADING})
        const response=await fetch(`https://api.zippopotam.us/in/${postalCode}`)
        const data=await response.json()
        dispatch({type:LOCATION_SUCCESS,payload:data})
    } catch (error) {
        dispatch({type:LOCATION_ERROR})
        return error
    }
}